var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 6.75V5.25C4.25 3.17893 5.92893 1.5 8 1.5C9.53774 1.5 10.8593 2.42557 11.438 3.75M8 10.125V11.625M5.6 15H10.4C11.6601 15 12.2902 15 12.7715 14.7548C13.1948 14.539 13.539 14.1948 13.7548 13.7715C14 13.2902 14 12.6601 14 11.4V10.35C14 9.08988 14 8.45982 13.7548 7.97852C13.539 7.55516 13.1948 7.21095 12.7715 6.99524C12.2902 6.75 11.6601 6.75 10.4 6.75H5.6C4.33988 6.75 3.70982 6.75 3.22852 6.99524C2.80516 7.21095 2.46095 7.55516 2.24524 7.97852C2 8.45982 2 9.08988 2 10.35V11.4C2 12.6601 2 13.2902 2.24524 13.7715C2.46095 14.1948 2.80516 14.539 3.22852 14.7548C3.70982 15 4.33988 15 5.6 15Z",
    stroke: "#5C5C5C",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ffe09243253949734cff6b48701a7e2a.svg";
export { ForwardRef as ReactComponent };